import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { Router } from '@angular/router';
import { TranslateModule } from '@ngx-translate/core';
import { SetupTwoFactorAuthChooserComponent } from 'projects/components/setup-two-factor-auth-chooser/setup-two-factor-auth-chooser.component';
import { TokenService } from 'projects/login/src/app/services/auth/token.service';

@Component({
  selector: 'pay-login-two-factor-setup',
  imports: [TranslateModule, SetupTwoFactorAuthChooserComponent],
  templateUrl: './two-factor-setup.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TwoFactorSetupComponent {
  private readonly _router = inject(Router);
  protected readonly token = inject(TokenService);

  returnToLogin() {
    this._router.navigate(['/']).then();
  }
}
